module.exports = __webpack_public_path__ + "static/media/closed-eye.00cf5ca0.svg";